import * as React from "react";
import { WidgetFrame, Icon, IconCollection } from "../studio/index.js";
export { IconSample };
/**
 * Примеры иконок.
 * @returns {JSX.Element} Элемент JSX.
 */
function IconSample() {
  const rows = [];
  for (const iconName in IconCollection)
    rows.push(
      <tr key={iconName}>
        <td><Icon name={iconName} /></td>
        <td>{iconName}</td>
      </tr>);
  return (
    <WidgetFrame icon="grid" title={IconSample.title}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
        <div>
          <table style={{ fontSize: "2em" }}>
            {rows}
          </table>
        </div>
        <div>
          <p>
            Шрифтовая иконка: <Icon name="home" />
          </p>
          <p>
            Цветная иконка: <Icon name="ru" />
          </p>
          <p>
            Вращающаяся иконка: <Icon name="loading" />
          </p>
          <p>
            Произвольная вращающаяся иконка:&nbsp;
            <Icon name="home" className="spin_icon" />
          </p>
          <p>
            Произвольного размера, цвета и оформления:<br />
            <Icon name="home" className="my_icon spin_icon" />
            <style>
              .my_icon
              {"{"}
              font-size: 32px;
              color: red;
              background: green;
              padding: 32px;
              border-radius: 48px;
              {"}"}
            </style>
          </p>
        </div>
      </div>
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
IconSample.title = "Иконки";
